import DivLoader from 'components/divloader/DivLoader';
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { generateBlankCheckoutLink } from "api/clients";
import toast from 'react-hot-toast';

function ClientCheckout() {

    const { client_id, client_secret } = useParams()
    const [initialLoading,setInitialLoading] = useState(true);
    
    const generateLink = () => {
        setInitialLoading(true);
        generateBlankCheckoutLink({},client_id,client_secret)
        .then((response) => {
          window.location.replace(response?.data?.payment_link);
        }).catch((err) => {
          toast.error(
            err?.response?.data?.message ??
              "Something went wrong while cancelling subscription"
          );
          
        });
    }

    useEffect(() => {
        generateLink()
    },[])

    return (
        <>
            {initialLoading ? (
                <div className="mt-5 pt-5">
                    <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                    <p className="text-center">Generating checkout link, once link generated you will redirected to checkout page....</p>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default ClientCheckout
